module.exports = __webpack_public_path__ + "img/check.5d4f5805.svg";